<template>
  <div class="category-card" @click="handleCtaClick" :title="ctaCopy">
    <ImageContentful
      class="category-card__image"
      :src="backgroundUrl"
      :isBackgroundImage="true"
      containerSelector=".category-card"
      :lazyload="true"
    />
    <Typography
      :variant="TYPOGRAPHY_VARIANTS.H3"
      :type="TYPOGRAPHY_TYPES.HEADING_MEDIUM"
      class="category-card__title"
      isBold
    >
      <FormattedText :text="title" />
    </Typography>
  </div>
</template>

<script>
import { responsiveMixin, Typography, TYPOGRAPHY_VARIANTS, TYPOGRAPHY_TYPES } from 'on-ui'
import ImageContentful from '@/components/_shared/ImageContentful.vue'
import FormattedText from '@/components/_shared/FormattedText.vue'

export default {
  name: 'CategoryCard',
  components: {
    Typography,
    ImageContentful,
    FormattedText,
  },
  mixins: [responsiveMixin],

  props: {
    title: {
      type: String,
      required: true,
    },
    backgroundUrl: {
      type: String,
      default: '',
    },
    ctaUrl: {
      type: String,
      default: '',
    },
    ctaCopy: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      TYPOGRAPHY_VARIANTS,
      TYPOGRAPHY_TYPES,
      isMouseOverContent: false,
    }
  },

  methods: {
    handleCtaClick() {
      this.$emit('on-click')
      // navigates to URL
      window.location.href = this.ctaUrl
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~on-ui/packages/styles/colors.scss';
@import '@/assets/stylesheets/base/animations.scss';

$category-card-transition: all $transition-time-slow $ease-in-out-circ;
$category-card-height-mq-large: 451px;
$category-card-height-mq-larger: 539px;
$category-card-height-mq-cinema: 630px;

.category-card {
  width: 100%;
  position: relative;
  transition: $category-card-transition;
  cursor: pointer;
  margin: 1rem 0;

  &:before {
    content: '';
    display: block;
    padding-top: 156%;
  }

  @media ($tablet-large-up) {
    &:before {
      padding-top: 137%;
    }
  }

  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    transition: $category-card-transition;
    pointer-events: none;

    &:before {
      transition: $category-card-transition;
      transform-origin: center bottom;
      opacity: 0.5;
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background: linear-gradient(to top, $color-background-overlay-dark, transparent);
    }
  }

  &__title {
    pointer-events: none;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 24px;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: $color-white;
    transition: $category-card-transition;
    opacity: 0;

    &.typography--heading-medium {
      @media ($desktop-huge-up) {
        font-size: 36px;
        line-height: 1.4;
      }
    }

    @media ($tablet-up) {
      opacity: 1;
    }
  }

  @mixin cardActive {
    .category-card {
      &__image {
        transition-timing-function: $ease-out-circ;
        transform: scale(1.1);

        &:before {
          opacity: 1;
          transform: scaleY(4);
          transition-timing-function: $ease-out-circ;
          transition-delay: 150ms;
        }
      }

      &__title {
        transition-timing-function: $ease-out-circ;
        opacity: 1;
      }
    }
  }

  @media (max-width: $breakpoint-tablet) {
    .swiper-slide-active & {
      @include cardActive();
    }
  }

  @media ($tablet-up) {
    &:hover {
      @include cardActive();
    }
  }
}
</style>
